<style lang="scss" scoped>
.help-container {
  position: relative;
};

.help-icon {
  position: absolute;
  cursor: pointer;
  z-index: 999;
}

.slide-fade-enter-active, .slide-fade-leave-active {
  transition: all .3s ease;
}

.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active em versões anteriores a 2.1.8 */ {
  transform: translateY(-10px);
  opacity: 0;
}
</style>

<template>
  <div class="help-container">
    <span
      class="help-icon"
      :style="{ top, right, }"
      @click="displayHelp = !displayHelp"
    >
      <font-awesome-icon
        :icon="displayHelp ? 'times-circle' : 'question-circle'"
        size="lg"
      />
    </span>
    <transition name="slide-fade">
      <b-row v-if="displayHelp">
        <b-col
          class="pt-4 p-3 mb-2"
          :class="{
            'pt-2' : displayHelp,
            'bottom-border': displayBorder,
          }"
        >
            <slot></slot>
        </b-col>
      </b-row>
    </transition>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faQuestionCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

library.add([faQuestionCircle, faTimesCircle]);

export default {
  props: {
    top: {
      type: String,
      default() { return '.4rem'; },
    },
    right: {
      type: String,
      default() { return '0'; },
    },
    displayBorder: {
      type: Boolean,
      default() { return true; },
    },
  },
  data() {
    return {
      displayHelp: false,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utils/hints/HelpHint.vue